<template>
  <div class="feedback div-layout">
    <!-- <div class="metulist">
        <ul>
            <li :class="[item.type===active?'active':'']" v-for="item in metulist" :key="item.type"  @click="hanldeChange(item)">
                {{item.value}}
            </li>
        </ul>
    </div>-->
    <module-title title="意见反馈" />
    <!-- <h3 class="title">消息列表</h3> -->
    <!-- 消息列表 -->
    <el-form
      ref="searchForm"
      :model="searchForm"
      :inline="true"
      label-position="right"
      label-width="150px"
    >
      <el-form-item label="终端：" prop="type">
        <el-select
          v-model="searchForm.dictsType.name"
          name="terminal"
          size="medium"
          class="handle-form-input"
          @change="handleSearchFilter"
        >
          <el-option
            v-for="item in metulist"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <!-- 消息列表 -->
    <!-- <multiple-box :visible="isSelection" :selection-num="selectionNum">
      <span
        class="handle-span"
        @click="handleSign('more',$event,1)"
      >批量标记为已处理</span>
      <span
        class="handle-span"
        @click="handleSign('more',$event,0)"
      >批量标记为未处理</span>
    </multiple-box>-->
    <el-table
      v-loading="listLoading"
      :data="feedbackList"
      element-loading-text="Loading"
      class="list-table"
    >
      <!-- <el-table-column type="selection" width="55" align="center" /> -->
      <el-table-column type="index" width="55" align="center" label="序号" />
      <el-table-column label="反馈内容" prop="content" align="left">
        <template slot-scope="scope">
          <!-- 0 全部消息 1会员审核  2活动审核  3订单审核 -->
          <span class="link" @click="detailsShow(scope.row)">{{ scope.row.content }}</span>
        </template>
      </el-table-column>
      <el-table-column label="账号" prop="account" align="center" width="115px" show-overflow-tooltip />
      <el-table-column label="终端" prop="terminalName" align="center" width="135px" show-overflow-tooltip />
      <!-- <el-table-column label="联系方式" prop="phone" align="center" width="135px" />
      <el-table-column label="消息类型" prop="status" align="center" width="105px">
        <template slot-scope="scope">
          0 全部消息 1会员审核  2活动审核  3订单审核
          {{scope.row.status===1?'已处理':'未处理'}}
        </template>
      </el-table-column>-->
      <el-table-column label="反馈时间" prop="createDate" align="center" width="185px">
        <template slot-scope="scope">
          {{ formatTimeToStr(scope.row.createDate) }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作" width="155px" prop="status" align="center">
        <template slot-scope="scope">
          <el-button
            type="success"
            size="small"
            v-if="scope.row.status===0"
            icon="el-icon-document-delete"
            @click="handleSign('one',scope.row,1)"
          >标记为已处理</el-button>
          <el-button
            type="primary"
            size="small"
            v-else
            icon="el-icon-document-delete"
            @click="handleSign('one',scope.row,0)"
          >标记为未处理</el-button>
        </template>
      </el-table-column>-->
    </el-table>
    <div class="pagination">
      <pagination
        :total="searchForm.total"
        :page.sync="searchForm.pageNum"
        :limit.sync="searchForm.pageSize"
        @pagination="pageCurriculumList"
        @handleSizeChange="handleSizeChange"
      />
    </div>
    <!-- 通知详情弹框start -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="hiddenVariable.dialogDetailVisible"
      :title="handleTitle"
      width="650px"
    >
      <Notice
        :props-content="feedbackContent"
        @closeDialog="hiddenVariable.dialogDetailVisible = false"
      />
    </el-dialog>
    <!-- 通知详情弹框end -->
  </div>
</template>

<script>

//

import Notice from './notice.vue';
import { formatTimeToStr } from '@/utils/index';
import { mapGetters } from 'vuex';

// 获取API
import {
  getDictsType,
  getFeedBackInfos
  // getFeedBackStatus
} from '@/api/productOperation/mrDesk/feedback';

export default {
  name: 'Feedback',
  components: {
    Notice
  },
  data() {
    return {
      listLoading: false,
      handleTitle: '',
      active: 0,
      hiddenVariable: {
        // 详情
        dialogDetailVisible: false // 详情标识
      },
      // 搜索表单
      searchForm: {
        id: '',
        dictsType: {
          code: '',
          name: ''
        },
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      terminaltypeArr: [],
      dictsType: 'terminal_type ',
      metulist: [],
      feedbackList: [],
      // multipleSelection: [], // 表格多选,
      feedbackContent: {}
    };
  },
  computed: {
    ...mapGetters(['currentProdeuctId']),
    // 是否多选
    // isSelection() {
    //   return this.multipleSelection.length > 0;
    // },
    // // 多选数量
    // selectionNum() {
    //   return this.multipleSelection.length;
    // },
    formatTimeToStr() {
      return formatTimeToStr;
    }
  },
  mounted() {
    this.getType();
  },
  methods: {
    // 获取反馈类型列表
    getType() {
      getDictsType(this.dictsType).then(res => {
        if (res.data && res.data.length) {
          this.metulist = res.data;
          this.metulist.unshift({
            name: '全部',
            code: ''
          });
          this.searchForm.dictsType.name = res.data[0].code;
          this.searchForm.dictsType.code = res.data[0].code;
          this.listLoading = true;
          this.getInfo();
        }
      });
    },
    // 获取反馈列表
    getInfo() {
      getFeedBackInfos({
        terminalCode: this.searchForm.dictsType.code,
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize,
        productId: 'C001'
      })
        .then(res => {
          this.listLoading = false;
          if (res.data === null || res.data === '' || res.data === 'undefind') {
            this.feedbackList = [];
            this.searchForm.total = 0;
          } else {
            this.feedbackList = res.data.list;
            this.searchForm.total = res.data.total;
          }
        })
        .catch(err => {
          this.$message({
            type: 'warning',
            message: '暂无数据'
          });
          this.listLoading = false;
          console.log(err);
        });
    },
    // 条件查询
    handleSearchFilter(val) {
      this.searchForm.dictsType.code = val;
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 10;
      this.listLoading = true;
      this.getInfo();
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.getInfo();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.getInfo();
    },
    // handleSelectionChange(val) {
    //   this.multipleSelection = val;
    // },
    // 操作
    // handleSign(val, row, statusNum) {
    //   let noticeIds = [];
    //   const status = statusNum;
    //   if (val === 'one') {
    //     noticeIds.push(row.id);
    //   } else if (val === 'more' && this.multipleSelection.length > 0) {
    //     noticeIds = this.multipleSelection.map(x => x.id);
    //   }
    //   this.$confirm(
    //     `确定要标记${this.multipleSelection.length > 0 ? '所选' : '该条'}为${
    //       status === 1 ? '已处理' : '未处理'
    //     }?`,
    //     '提示',
    //     {
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //       type: 'warning'
    //     }
    //   )
    //     .then(() => {
    //       var option = {
    //         ids: noticeIds,
    //         status: status
    //       };
    //       getFeedBackStatus(option).then(res => {
    //         this.listLoading = true;
    //         this.getInfo();
    //       });
    //     })
    //     .catch(() => {});
    // },
    // 详情
    detailsShow(val) {
      this.handleTitle = '反馈内容';
      this.hiddenVariable.dialogDetailVisible = true;
      this.feedbackContent = val;
    },
    hanldeChange(val) {
      this.active = val.type;
    }
  }
};
</script>
<style lang="scss" scoped>
.feedback {
  .metulist {
    margin-bottom: 20px;
    margin-left: 10px;
    ul {
      padding: 0;
      margin: 0;
      height: 52px;
      line-height: 52px;
      li {
        display: inline;
        padding: 8px 30px;
        border: #e2e2e2 1px solid;
        margin: 10px;
        border-radius: 4px;
      }
      li.active {
        color: #fff;
        font-weight: bold;
        background: #409eff;
        border: #409eff 1px solid;
      }
    }
  }
  .title {
    border-left: 5px solid #1890ff;
    margin-left: 20px;
    padding-left: 10px;
    margin-bottom: 20px;
  }
  .link {
    cursor: pointer;
    color: #409eff;
    text-decoration: underline;
  }
}
</style>
